import React from "react";
import { IconButton, useTheme } from "@mui/material";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const PreviousNextButton = ({ action, type }) => {

    const theme = useTheme();
    const disabled = !Boolean(action);

    return (
        <IconButton
            size="small"
            disabled={disabled}
            onClick={action}
            aria-label={type === "previous" ? "Jogo anterior" : "Próximo jogo"}
            sx={{
                backgroundColor: disabled ? "transparent" : theme.palette.whiteSmoke.main,
                "&:hover": { backgroundColor: theme.palette.whiteSmoke.dark },
            }}
        >
            {type === "previous" ? <FaChevronLeft size={13} /> : <FaChevronRight size={13} />}
        </IconButton>
    );
}

export default PreviousNextButton;
